import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import Logo from "./Logo";
import { SITE } from "../site";

const EXPLORE = [
    { to: "/", label: "Home" },
    { to: "/offers", label: "Offers" },
    { to: "/coupons", label: "Coupons" },
    { to: "/brands", label: "Brands" },
    { to: "/categories", label: "Categories" },
    { to: "/blog", label: "Blog" },
    { to: "/price-comparison", label: "Price Comparison" },
    { to: "/flights", label: "Flights" },
    { to: "/hotels", label: "Hotels" },
    { to: "/card-offers", label: "Card Offers" },
    { to: "/about", label: "About" },
    { to: "/features", label: "Features" },
    { to: "/contact", label: "Contact" },
];

const LEGAL = [
    { to: "/privacy-policy", label: "Privacy Policy" },
    { to: "/terms-and-conditions", label: "Terms & Conditions" },
    { to: "/affiliate-disclosure", label: "Affiliate Disclosure" },
    { to: "/editorial-policy", label: "Editorial Policy" },
    { to: "/disclaimer", label: "Disclaimer" },
    { to: "/delete-account", label: "Delete Account" },
];

const Footer = () => (
    <footer data-testid="site-footer" className="bg-india text-cream">
        <div className="mx-auto max-w-7xl px-6 py-16 sm:px-8 sm:py-20 lg:px-12">
            <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
                <div className="md:col-span-5">
                    <Logo dark />
                    <p
                        data-testid="footer-tagline"
                        className="mt-5 font-display text-2xl font-medium tracking-tight text-cream"
                    >
                        “{SITE.tagline}”
                    </p>
                    <p className="mt-3 max-w-sm text-sm leading-relaxed text-cream/70">
                        Smart shopping and travel discovery — on the web and in the SahiKhoj mobile app.
                    </p>
                    <p className="mt-6 inline-flex items-center gap-2 rounded-full border border-cream/20 px-4 py-2 font-mono text-[11px] uppercase tracking-[0.18em] text-cream/70">
                        <span className="h-1.5 w-1.5 rounded-full bg-saffron" />
                        App launching soon on Google Play
                    </p>
                </div>
                <div className="md:col-span-2">
                    <h3 className="font-mono text-xs uppercase tracking-[0.22em] text-cream/50">
                        Explore
                    </h3>
                    <ul className="mt-5 space-y-3">
                        {EXPLORE.map(({ to, label }) => (
                            <li key={to}>
                                <Link
                                    to={to}
                                    data-testid={`footer-link-${label.toLowerCase()}`}
                                    className="text-sm text-cream/80 transition-colors hover:text-saffron"
                                >
                                    {label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="md:col-span-2">
                    <h3 className="font-mono text-xs uppercase tracking-[0.22em] text-cream/50">
                        Legal
                    </h3>
                    <ul className="mt-5 space-y-3">
                        {LEGAL.map(({ to, label }) => (
                            <li key={to}>
                                <Link
                                    to={to}
                                    data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                                    className="text-sm text-cream/80 transition-colors hover:text-saffron"
                                >
                                    {label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="md:col-span-3">
                    <h3 className="font-mono text-xs uppercase tracking-[0.22em] text-cream/50">
                        Contact
                    </h3>
                    <div
                        data-testid="footer-support-email"
                        className="mt-5 rounded-2xl border border-cream/15 bg-cream/5 p-4"
                    >
                        <a
                            href={`mailto:${SITE.supportEmail}`}
                            className="flex items-center gap-2 text-sm font-medium text-cream transition-colors hover:text-saffron"
                        >
                            <Mail className="h-4 w-4 text-saffron" />
                            {SITE.supportEmail}
                        </a>
                    </div>
                </div>
            </div>
            <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-cream/10 pt-8 sm:flex-row sm:items-center">
                <p data-testid="footer-copyright" className="text-sm text-cream/60">
                    © {SITE.name}
                </p>
                <p className="font-mono text-xs tracking-[0.18em] text-cream/40">
                    {SITE.domain}
                </p>
            </div>
        </div>
    </footer>
);

export default Footer;
